import type { TenantContext } from '@jira/platform__tenant-context-types/src/tenant-context.tsx';
import {
	type ApplicationKey,
	SERVICE_DESK,
	CORE,
	SOFTWARE,
	PRODUCT_DISCOVERY,
} from '@jira/platform__application-editions/src/application-key.tsx';

const getExplicitlyLicensedProducts = (tenantContext: TenantContext): ApplicationKey[] => {
	const { licensedProducts } = tenantContext;
	const result: ApplicationKey[] = [];
	licensedProducts[CORE] && result.push(CORE);
	licensedProducts[SERVICE_DESK] && result.push(SERVICE_DESK);
	licensedProducts[SOFTWARE] && result.push(SOFTWARE);
	licensedProducts[PRODUCT_DISCOVERY] && result.push(PRODUCT_DISCOVERY);
	return result;
};

export default getExplicitlyLicensedProducts;
